<template>
	<div>
		<div class="data32">
			<div class="data32Til">{{list.data.menuTitle}}</div>
			<div class="data32Cen">
				<div v-for="(item,index) in list.data.desc" :key="index">{{item.text}}</div>
			</div>
			<div style="overflow-x: auto;">
				<div class="data32Box">
					<div class="data32For" v-for="(item,index) in list.data.bgImgs" :key="index">
						<img :src="item" />
					</div>
				</div>
			</div>

		</div>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Object,
				default: {}
			}
		},
		data() {
			return {
				// list:[
				// 	{
				// 		img:require('@/assets/product/page8/xhk.png')
				// 	},
				// 	{
				// 		img:require('@/assets/product/page8/byhk.png')
				// 	},
				// 	{
				// 		img:require('@/assets/product/page8/hxk.png')
				// 	},
				// ]
			}
		},
		mounted() {

		},
		methods: {

		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.data32 {
		width: 1200px;
		margin: 0 auto;
		padding-bottom: 150px;

		.data32Til {
			font-size: 45px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #000000;
			margin-bottom: 40px;
		}

		.data32Cen {
			font-size: 18px;
			font-family: Source Han Sans CN;
			font-weight: 300;
			color: #000000;
			margin-bottom: 40px;

			>div {
				white-space: pre-line;
			}
		}

		.data32Box {
			display: flex;
			align-items: center;

			.data32For:not(:last-child) {
				margin-right: 35px;
			}

			.data32For {
				img {
					width: 375px;
					height: 600px;
					object-fit: cover;
				}
			}
		}
	}

	@media screen and (max-width:1200px) {
		.data32 {
			width: 100% !important;
			padding: 0 30px 30px !important;
			box-sizing: border-box;
			.data32Til{
				font-size: 24px !important;
				margin-bottom:20px !important;
			}
			.data32Cen{
				font-size: 14px !important;
				margin-bottom: 20px !important;
			}
			.data32For {
				min-width:100% !important;
				img {
					max-width:100% !important;
					height: auto !important;
					object-fit: contain;
				}
			}
		}
	}
</style>